{
  "safetyDataSheets": "안전 보건 자료 및 물품 정보 자료",
  "bodyContentParagraph1": "화학 제품에 대한 안전 보건 자료(SDS) 및 인쇄 판재, 장비와 같은 항목에 대한 물품 정보 자료(AIS)에는 국가별 규제 정보가 포함되어 있습니다.",
  "bodyContentParagraph2": "SDS 및 AIS는 안전한 사용 및 폐기에 대한 지침을 제공하기 위해 다른 제품에도 제공될 수 있지만, 그 존재가 해당 제품이 화학 물질 또는 혼합물로서 규제 대상임을 의미하지는 않습니다.",
  "bodyContentParagraph3": "SDS 또는 AIS를 검색하는 방법:",

  "bodyContentList1": "보고서 카테고리(제품 SDS 또는 물품 정보 자료)를 선택합니다.",
  "bodyContentList2": "국가 - 언어를 선택합니다. 참고: 모든 보고서가 모든 언어로 존재하는 것은 아닙니다.",
  "bodyContentList3": "<strong> <b>SDS를 찾는 방법:</b> </strong> 카탈로그/재주문 번호(공백이나 하이픈 없음) 또는 제품 라벨에서 확인되는 부분/전체 제품 이름을 적절한 검색 항목에 입력합니다.",
  "bodyContentList4": "<strong> <b>AIS를 찾는 방법: </b> </strong> 키워드 검색 필드에 제품 라벨에서 확인되는 부분/전체 제품 이름을 입력합니다.",
  "bodyContentList5": "검색 버튼을 클릭합니다.",

  "reportCategory": "보고 항목:",
  "country": "국가/지역:",
  "language": "언어:",
  "catalogNumber": "카탈로그 / 리오더 번호:",
  "productName": "제품명 / 키워드:",
  "search": "검색",

  "inquiriesSentTo": "SDS를 검색했지만 정보를 찾을 수 없는 경우 아래 정보를 확인하세요. <a href='mailto:us-pep@kodak.com'>us-pep@kodak.com</a> 으로 문의를 보낼 수 있습니다.",

  "platesAndEquipment": "판재 및 장비",
  "platesAndEquipmentContent": "코닥 판재 및 코닥 장비는 SDS가 필요하지 않습니다. 정상적인 조건에서 이러한 제품이 물리적 위험이나 건강 위험을 초래하지 않기 때문입니다.",

  "kodakBrandPartner": "코닥 브랜드 파트너 제품",
  "kodakBrandPartnerContent": "요청하시는 정보는 코닥 브랜드 파트너로 간주되는 회사에서 판매하는 제품에 대한 것일 수 있습니다. 이 경우 SDS 또는 물품 정보는 코닥 브랜드 파트너에게 직접 문의하시기 바랍니다.",

  "batteries": "배터리",
  "strandEurope": "<a href='https://www.kodakbatteries.strandeurope.com' target='_blank'>www.kodakbatteries.strandeurope.com</a> 에서 스트랜드 유럽(Strand Europe)에 직접 문의하시기 바랍니다.",

  "consumerAndProfessionalPhotographicProducts": "소비자 및 전문가용 사진 제품 및 문서 스캐너",
  "kodakAlaris": "<a href='https://www.kodakalaris.com' target='_blank' >www.kodakalaris.com</a> 으로 코닥 알라리스(Kodak Alaris)에 문의하시기 바랍니다.",

  "divestedProducts": "매각된 제품",
  "devistedProductsContent": "요청하시는 정보는 매각의 일환으로 다른 회사에 판매된 제품에 대한 것일 수 있습니다. 이 경우 SDS 또는 물품 정보는 해당 회사에 직접 문의하시기 바랍니다.",

  "medicalDentalAndIndustrialXrayProducts": "의료, 치과, 산업용 X선 제품",
  "carestreamHealth": "1-888-777-2072 또는 <a href='https://www.carestream.com' target='_blank'>www.carestream.com</a>에서 케어스트림 헬스(Carestream Health, Inc.)에 문의하시기 바랍니다.",

  "laboratoryAndResearchChemicals": "실험실 및 연구용 화학물질",
  "fisherChemicalCompany": "1-800-766-7000 또는<a href='https://www.fishersci.com' target='_blank' >www.fishersci.com</a>에서 피셔 케미컬 컴퍼니(Fisher Chemical Company)에 문의하시기 바랍니다.",

  "fibersAndPlastics": "섬유 및 플라스틱",
  "eastmanChemicalCompany": "섬유 및 플라스틱<a href='https://www.eastman.com' target='_blank' >www.eastman.com</a>에서 이스트먼 케미컬 컴퍼니(Eastman Chemical Company)에 문의하시기 바랍니다.",

  "copyright": "Copyright ©2024 Eastman Kodak Company. All Rights Reserved.",

  "termsOfUse": "이용 약관",
  "privacy": "개인 정보 보호",
  "accessibility": "접근성",
  "GridHeaders": {
    "Report Category":"보고 항목",
    "Country":"국가",
    "Language":"언어",
    "Document Revision Number":"문서 개정 번호",
    "CatalogNumber":"카탈로그 번호",
    "Document Name": "문서 이름"
  },
  "HeaderLinks":"https://www.kodak.com/ko",

  "FallbackMessage":"불편을 드려 죄송합니다. 현재 서비스를 이용할 수 없습니다. 잠시 후 다시 시도해 주세요.",
  "report_Categories_dropdown": [
    {"CatogeryType":"SDS" ,"displayName": "제품 SDS" },
    {"CatogeryType":"AIS" ,"displayName":"Article Information Sheet"},
    {"CatogeryType":"DGW","displayName": "Dangerous Goods (DG) Worksheet"}
  ]
}
